import { Turbo } from "@hotwired/turbo-rails"

// <turbo-stream action="close_modal" target="<dom-id>">
// Closes the modal identified by the target element id via its modal_controller.
Turbo.StreamActions.close_modal = function() {
  const id = this.getAttribute("target")
  const el = id && document.getElementById(id)
  if (!el) return
  const controller = window.Stimulus?.getControllerForElementAndIdentifier(el, "modal")
  controller?.close()
}
